import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';

export class BlackListCoontroller {
	async checkBlackList(request: { iin?: string, fio?: string }): Promise<any> {
		if (request?.iin) {
			const iin = encodeURIComponent(request.iin);
			return await server.post(`/NB/searchBlackList?iin=${iin}`, {}, {
				baseURL: BACKEND_URL
			});
		} else {
			const fio = encodeURIComponent(request.fio || "");
			return await server.post(`/NB/searchBlackList?fio=${fio}`, {}, {
				baseURL: BACKEND_URL
			});
		}
	}

	async checkSavedBlackList(request: { iin?: string, fio?: string }): Promise<any> {
		if (request?.iin) {
			const iin = encodeURIComponent(request.iin);
			return await server.post(`/NB/searchSavedBlackLists?iin=${iin}`, {}, {
				baseURL: BACKEND_URL
			});
		} else {
			const fio = encodeURIComponent(request.fio || "");
			return await server.post(`/NB/searchSavedBlackLists?fio=${fio}`, {}, {
				baseURL: BACKEND_URL
			});
		}
	}

	async getId2(login: string): Promise<any> {
		return await server.get(`Id2/getInfo/${login}`, {
			baseURL: BACKEND_URL
		});
	}
}